import React, { useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { BsDot } from "react-icons/bs";
import {
  FaCheckDouble,
  FaInfoCircle,
  FaPhoneAlt,
  FaPlus,
  FaSearch,
  FaTimes,
  FaVideo,
} from "react-icons/fa";
import {
  FiCamera,
  FiCheckCircle,
  FiImage,
  FiMapPin,
  FiMoreVertical,
  FiMusic,
  FiSend,
  FiSmile,
  FiUser,
} from "react-icons/fi";
import EmojiPicker from "emoji-picker-react";

const Chat = () => {
  const [search, setSearch] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [message, setMessage] = useState("");

  const handleEmojiClick = (emojiData) => {
    setMessage((prev) => prev + emojiData.emoji);
  };

  const users = [
    {
      id: 1,
      name: "Mark Smith",
      message: "Hey Sam! Did you Check...",
      time: "10:10 AM",
      image: "https://i.pravatar.cc/150?img=8",
      unread: 0,
      active: true,
    },

    {
      id: 2,
      name: "Eugene Sikora",
      message: "How are you today?",
      time: "08:26 AM",
      image: "https://i.pravatar.cc/150?img=7",
      unread: 5,
    },

    {
      id: 3,
      name: "Robert Fassett",
      message: "Here are some files...",
      time: "Yesterday",
      image: "https://i.pravatar.cc/150?img=6",
      unread: 2,
    },

    {
      id: 4,
      name: "Andrew Fletcher",
      message: "Use tools like Trello...",
      time: "Yesterday",
      image: "https://i.pravatar.cc/150?img=5",
      unread: 0,
    },

    {
      id: 5,
      name: "Anna Johnson",
      message: "How are your Today",
      time: "12:54 PM",
      image: "https://i.pravatar.cc/150?img=1",
      unread: 0,
    },
    {
      id: 6,
      name: "Raj Kumar",
      message: "How are you",
      time: "12:55 PM",
      image: "https://i.pravatar.cc/150?img=15",
      unread: 1,
    },
    {
      id: 7,
      name: "Virat Mourya",
      message: "Fine n u",
      time: "12:58 PM",
      image: "https://i.pravatar.cc/150?img=14",
      unread: 0,
    },
  ];

  const chatMessages = [
    {
      id: 1,
      type: "receive",
      name: "Mark Smith",
      time: "02:39 PM",
      message: "Hey mark! Did you check out the new logo design?",
      avatar: "https://i.pravatar.cc/150?img=8",
    },
    {
      id: 2,
      type: "sent",
      name: "You",
      time: "02:39 PM",
      message: "Not yet. Can you send it here?",
      avatar: "https://i.pravatar.cc/150?img=10",
    },
    {
      id: 3,
      type: "receive",
      name: "Mark Smith",
      time: "02:40 PM",
      message: "Sure! Please check the below logo Attached!!!",
      avatar: "https://i.pravatar.cc/150?img=8",
      attachments: [
        "https://picsum.photos/100/80?random=1",
        "https://picsum.photos/100/80?random=2",
      ],
    },
    {
      id: 4,
      type: "date",
      date: "Today",
    },
    {
      id: 5,
      type: "sent",
      name: "You",
      time: "10:00 AM",
      message:
        "Looks clean! I like the font. Maybe try a slightly darker blue?",
      avatar: "https://i.pravatar.cc/150?img=10",
    },
    {
      id: 6,
      type: "receive",
      name: "Mark Smith",
      time: "10:05 AM",
      message: "Perfect! That layout will work great on the landing page. 👍",
      avatar: "https://i.pravatar.cc/150?img=8",
    },
  ];

  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      console.log(file);
    }
  };

  const filteredUsers = users.filter((user) =>
    user.name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="p-3">
      <div className="chat-wrapper">
        <div className="card shadow-none mb-0">
          <div className="card-body p-0">
            <div className="d-lg-flex">
              <div className="chat-user-nav border-end bg-white h-100">
                {/* Header */}
                <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                  <div className="d-flex align-items-center">
                    <img
                      src="https://i.pravatar.cc/150?img=10"
                      alt="user"
                      width="45"
                      height="45"
                      className="rounded-circle me-2"
                    />

                    <div>
                      <h6 className="mb-0">James Hong</h6>

                      <small className="text-muted">Admin</small>
                    </div>
                  </div>

                  <button className="btn btn-primary btn-sm rounded-circle">
                    <FaPlus />
                  </button>
                </div>

                {/* Search */}
                <div className="p-3 border-bottom">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>

                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search User"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>

                {/* Users */}
                <div className="chat-users p-2">
                  <h6 className="px-2 mb-3">All Messages</h6>

                  {filteredUsers.map((user) => (
                    <div
                      key={user.id}
                      className={`d-flex align-items-center justify-content-between rounded p-2 mb-2 user-list cursor-pointer ${
                        user.active ? "bg-light" : ""
                      }`}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          src={user.image}
                          alt={user.name}
                          width="45"
                          height="45"
                          className="rounded-circle me-2"
                        />

                        <div>
                          <h6 className="mb-0 fs-14">{user.name}</h6>

                          <small className="text-muted text-truncate d-block">
                            {user.message}
                          </small>
                        </div>
                      </div>

                      <div className="text-end">
                        <small className="d-block text-muted mb-1">
                          {user.time}
                        </small>

                        {user.unread > 0 ? (
                          <span className="badge bg-danger rounded-circle">
                            {user.unread}
                          </span>
                        ) : (
                          <span className="text-success">
                            <FaCheckDouble />
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex-fill chat-messages">
                {/* card start */}
                <div className="card border-0 mb-0">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 p-3 border-bottom">
                    {/* User Info */}
                    <div className="d-flex align-items-center">
                      <img
                        src="https://i.pravatar.cc/150?img=8"
                        alt="user"
                        width="50"
                        height="50"
                        className="rounded-circle me-2"
                      />

                      <div>
                        <h6 className="fs-14 fw-semibold mb-1">Mark Smith</h6>

                        <p className="mb-0 d-flex align-items-center text-success small">
                          <span
                            className="bg-success rounded-circle me-1"
                            style={{
                              width: "8px",
                              height: "8px",
                              display: "inline-block",
                            }}
                          ></span>
                          Online
                        </p>
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      {/* Voice Call */}
                      <button className="btn btn-light btn-sm rounded-circle">
                        <FaPhoneAlt />
                      </button>

                      {/* Video Call */}
                      <button className="btn btn-light btn-sm rounded-circle">
                        <FaVideo />
                      </button>

                      {/* Info */}
                      <button className="btn btn-light btn-sm rounded-circle">
                        <FaInfoCircle />
                      </button>

                      {/* Close */}
                      <button className="btn btn-light btn-sm rounded-circle d-md-none">
                        <FaTimes />
                      </button>
                    </div>
                  </div>

                  <div className="card-body p-0">
                    <div
                      className="message-body p-4 simplebar-scrollable-y"
                      data-simplebar="init"
                    >
                      <div className="simplebar-content-wrapper">
                        <div className="simplebar-content">
                          {chatMessages.map((chat) => {
                            if (chat.type === "date") {
                              return (
                                <div className="text-center mb-3" key={chat.id}>
                                  <span className="badge bg-light text-dark rounded-pill px-3 py-2">
                                    {chat.date}
                                  </span>
                                </div>
                              );
                            }

                            return (
                              <div
                                key={chat.id}
                                className={`chat-list ${
                                  chat.type === "sent" ? "ms-auto" : ""
                                } mb-3`}
                              >
                                <div
                                  className={`d-flex align-items-start ${
                                    chat.type === "sent"
                                      ? "justify-content-end"
                                      : ""
                                  }`}
                                >
                                  {chat.type === "receive" && (
                                    <span className="avatar online me-2 flex-shrink-0">
                                      <img
                                        src={chat.avatar}
                                        className="rounded-circle"
                                        alt={chat.name}
                                        width="40"
                                        height="40"
                                      />
                                    </span>
                                  )}

                                  <div>
                                    <div
                                      className={`d-flex align-items-center mb-1 ${
                                        chat.type === "sent"
                                          ? "justify-content-end"
                                          : ""
                                      }`}
                                    >
                                      {chat.type === "receive" ? (
                                        <>
                                          <h6 className="fs-14 mb-0">
                                            {chat.name}
                                          </h6>

                                          <p className="mb-0 d-inline-flex align-items-center ms-2">
                                            <BsDot className="mx-1" />
                                            {chat.time}
                                          </p>
                                        </>
                                      ) : (
                                        <>
                                          <p className="mb-0 d-inline-flex align-items-center">
                                            <FiCheckCircle
                                              className="text-success me-1"
                                              size={14}
                                            />
                                            {chat.time}
                                            <BsDot className="mx-1" size={18} />
                                          </p>

                                          <h6 className="fs-14 fw-semibold mb-0">
                                            {chat.name}
                                          </h6>
                                        </>
                                      )}
                                    </div>

                                    <div className="d-flex align-items-center">
                                      {chat.type === "sent" && (
                                        <Dropdown className="me-2">
                                          <Dropdown.Toggle
                                            variant="light"
                                            size="sm"
                                            className="border-0 shadow-none"
                                          >
                                            <FiMoreVertical size={18} />
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <Dropdown.Item>Reply</Dropdown.Item>
                                            <Dropdown.Item>
                                              Delete
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      )}

                                      <div
                                        className={`message-box p-3 rounded-3 ${
                                          chat.type === "sent"
                                            ? "bg-primary text-white"
                                            : "bg-light"
                                        }`}
                                        style={{ maxWidth: "400px" }}
                                      >
                                        <p className="mb-0 fs-14">
                                          {chat.message}
                                        </p>

                                        {chat.attachments && (
                                          <div className="d-flex gap-2 mt-2">
                                            {chat.attachments.map(
                                              (img, index) => (
                                                <img
                                                  key={index}
                                                  src={img}
                                                  alt="attachment"
                                                  className="rounded"
                                                  width="80"
                                                  height="60"
                                                />
                                              ),
                                            )}
                                          </div>
                                        )}
                                      </div>

                                      {chat.type === "receive" && (
                                        <Dropdown className="ms-2">
                                          <Dropdown.Toggle
                                            variant="light"
                                            size="sm"
                                            className="border-0 shadow-none"
                                          >
                                            <FiMoreVertical size={18} />
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <Dropdown.Item>Reply</Dropdown.Item>
                                            <Dropdown.Item>
                                              Delete
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      )}
                                    </div>
                                  </div>

                                  {chat.type === "sent" && (
                                    <span className="avatar ms-2 online flex-shrink-0">
                                      <img
                                        src={chat.avatar}
                                        className="rounded-circle"
                                        alt={chat.name}
                                        width="40"
                                        height="40"
                                      />
                                    </span>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div
                        className="simplebar-track simplebar-horizontal"
                        style={{ visibility: "hidden" }}
                      >
                        <div
                          className="simplebar-scrollbar"
                          style={{ width: 0, display: "none" }}
                        />
                      </div>
                      <div
                        className="simplebar-track simplebar-vertical"
                        style={{ visibility: "visible" }}
                      >
                        <div
                          className="simplebar-scrollbar"
                          style={{
                            height: 25,
                            transform: "translate3d(0px, 12px, 0px)",
                            display: "block",
                          }}
                        />
                      </div>
                    </div>
                    <div className="message-footer d-flex align-items-center border-top p-3">
                      {/* Input */}
                      <div className="flex-fill">
                        <input
                          type="text"
                          className="form-control border-0 shadow-none"
                          placeholder="Type something..."
                        />
                      </div>

                      {/* Actions */}
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="file"
                          accept="image/*"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleImageChange}
                        />

                        <button
                          onClick={handleImageClick}
                          type="button"
                          className="btn btn-icon btn-light"
                        >
                          <FiImage size={18} />
                        </button>

                        <div className="position-relative">
                          {/* Emoji Button */}
                          <button
                            type="button"
                            className="btn btn-icon btn-light"
                            onClick={() => setShowEmoji(!showEmoji)}
                          >
                            <FiSmile size={18} />
                          </button>

                          {/* Emoji Picker */}
                          {showEmoji && (
                            <div
                              className="position-absolute bottom-100 end-0 mb-2"
                              style={{ zIndex: 999 }}
                            >
                              <EmojiPicker onEmojiClick={handleEmojiClick} />
                            </div>
                          )}
                        </div>

                        <Dropdown align="end">
                          <Dropdown.Toggle
                            variant="light"
                            className="btn btn-icon border-0 shadow-none"
                          >
                            <FiMoreVertical size={18} />
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="p-2">
                            <Dropdown.Item className="d-flex align-items-center">
                              <FiCamera className="me-2" />
                              Camera
                            </Dropdown.Item>

                            <Dropdown.Item className="d-flex align-items-center">
                              <FiImage className="me-2" />
                              Gallery
                            </Dropdown.Item>

                            <Dropdown.Item className="d-flex align-items-center">
                              <FiMusic className="me-2" />
                              Audio
                            </Dropdown.Item>

                            <Dropdown.Item className="d-flex align-items-center">
                              <FiMapPin className="me-2" />
                              Location
                            </Dropdown.Item>

                            <Dropdown.Item className="d-flex align-items-center">
                              <FiUser className="me-2" />
                              Contact
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        {/* Send */}
                        <button
                          type="button"
                          className="btn btn-primary btn-icon"
                        >
                          <FiSend size={18} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat;
